import { call, put, takeLatest } from "redux-saga/effects";
import {
  searchSuccess,
  searchFailure,
  globalSearchTypes,
} from "../actions/globalSearch";
import {
  fetchv1DeviceDetailsEndPoint,
  fetchOrganizationEndPoint,
  fetchLocationEndPoint,
} from "../../configuration";
import { getRandomUUID } from "../../Token";

function* searchSaga(action) {
  try {
    const response = yield call(apiDownload, action.payload);
    const searchPattern = new RegExp('^' + action.payload, 'i');
    console.log("devices globalSearch", response[0].devices);
    const deviceSearchResults = response[0]?.devices?.length > 0 ? response[0].devices.filter((deviceSearchResult) => deviceSearchResult?.name).map((deviceSearchResult) => ({
      id: deviceSearchResult?.id,
      title: deviceSearchResult?.name,
      subtitle: deviceSearchResult?.description,
      isState: false,
      url: `/devices/${deviceSearchResult?.uid}/map`,
      menus: {
        views: [
          {
            type: "url",
            label: "View device dashboard",
            link: `/devices/${deviceSearchResult?.uid}/dashboard`,
          },
          {
            type: "state",
            label: "View device alerts",
            link: `/alerts`,
            state: {
              deviceId: deviceSearchResult?.name
            }
          },
          // {
          //   type: "state",
          //   label: "View organization alerts",
          //   link: `/alerts`,
          //   state: {
          //     organization: deviceSearchResult?.customdata?.organizationName
          //   }
          // },
          // {
          //   type: "state",
          //   label: "View location alerts",
          //   link: `/alerts`,
          //   state: {
          //     location: deviceSearchResult?.customdata?.locationName
          //   }
          // },
        ],
        actions: [
          {
            type: "url",
            label: "View devices",
            link: `/devices/${deviceSearchResult?.uid}/map`,
          },
        ],
      },
    })):[];
    // const organizationSearchResults = response[1]?.length > 0 ? response[1].filter((organizationSearchResult) => organizationSearchResult?.tags && organizationSearchResult?.tags.length > 0 && organizationSearchResult?.tags[0].kind === "ts.tag.org" && organizationSearchResult?.tags[0].org_name && searchPattern.test(organizationSearchResult?.tags[0].org_name)).map((organizationSearchResult) => ({
    //   id: organizationSearchResult?.id,
    //   title: organizationSearchResult?.tags[0]?.org_name,
    //   subtitle: "",
    //   isState: true,
    //   url: {
    //     value: `/organization`,
    //     state: organizationSearchResult
    //   },
    //   menus: {
    //     views: [
    //     ],
    //     actions: [
    //     ],
    //   },
    // })): [];
    // organizationSearchResults.sort((a, b) => a?.title.localeCompare(b?.title));

    const locationSearchResults = response[1]?.locations?.length > 0 ? response[1]?.locations?.filter((locationSearchResult) =>  locationSearchResult?.kind === "ts.tag.site" && locationSearchResult?.name ).map((locationSearchResult) => ({
      id: locationSearchResult?.id,
      title: locationSearchResult?.name,
      subtitle: "",
      isState: true,
      url: {
        value: `/locationdetails`,
        state: locationSearchResult
      },
      menus: {
        views: [
        ],
        actions: [
        ],
      },
    })):[];
    locationSearchResults && locationSearchResults.sort((a, b) => a?.title.localeCompare(b?.title));

    yield put(searchSuccess({
      totalDevices: response[0].totalCount,
      devices: deviceSearchResults,
      organizations: [],
      locations: locationSearchResults
    }));
  } catch (error) {
    yield put(searchFailure(error.message));
  }
}

async function apiDownload(searchquery) {
  const query = [
    fetch(fetchv1DeviceDetailsEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountname: sessionStorage.getItem("accountId"),
        filter:{
          $selection: `name like '%${searchquery}%'`,
          $limitnumber: 10,
          $pagenumber: 0,
        }
      }),
    }),
  // fetch(fetchOrganizationEndPoint(), {`
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
    //     "VZ-M2M-Token": getRandomUUID(),
    //   },
    //   body: JSON.stringify({
    //     accountname: sessionStorage.getItem("accountId"),
    //     filterType: "name",
    //     filterValue: searchquery,
    //     $sort: [{ field: "createdon", order: "desc" }]
    //   }),
    // }),
    fetch(fetchLocationEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountname: sessionStorage.getItem("accountId"),
        filter:{
        fields:{name: searchquery},
        $sort: [{ field: "createdon", order: "desc" }]
        }
      }),
    }),
  ];

  const result = [];
  const data = await Promise.allSettled(query);

  const dataLength = data.length;
  for (let i = 0; i < dataLength; i++) {
    const response = await data[i].value.json();
    result.push(response);
  }
  return result;
}

export default function* AssetsDownloadSaga() {
  yield takeLatest(globalSearchTypes.GLOBAL_SEARCH_REQUEST, searchSaga);
}

